import { string, shape, bool } from 'prop-types';

const problemActivityShape = shape({
  problem: string,
  initiatorName: string,
  note: string,
  loadId: string,
  eventId: string,
  eventTime: string,
  eventType: string,
  isAutomated: bool,
  resolvedAt: string,
});

export default problemActivityShape;
